import { SxProps } from "@mui/material";

export const sxTypographyTitle: SxProps = {
  fontFamily: 'UnimedSans-bold',
  color: '#383838',
  fontWeight: 700,
  fontSize: 24,
}

export const sxButton: SxProps = {
  borderRadius: '80px',
  padding: '24px 32px',
  height: '44px',
  maxWidth: '230px',
  '@media (max-width: 768px)': {
    maxWidth: 'unset'
  }
}

export const sxValidationMessage: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#D84141',
  fontSize: 12
}

export const sxLabel: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
}

export const sxOutlinedInputPasswordChange: SxProps = {
  minWidth: '350px',
  '@media (max-width: 768px)': {
    minWidth: 'unset'
  }
}